module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/heroMobile@2x.4de184f.png";